import {
  Component,
  Input,
  Output,
  ChangeDetectionStrategy,
  EventEmitter
} from '@angular/core';

import { Cell } from '../../../lib/data-set/cell';

@Component({
    selector: 'table-cell-view-mode',
    template: `
      <div>
        @switch (cell.getColumn().type) {
          @case ('custom') {
            <custom-view-component [cell]="cell"></custom-view-component>
          }
          @case ('html') {
            <div [innerHTML]="cell.newValue"></div>
          }
          @default {
            <div style="word-break: break-all;">
              @if (!hideLink()) {
                <a href="#" (click)="onLinkClick($event)">
                  {{ cell.getInitialValue() }}
                </a>
              }
              @if (hideLink()) {
                {{ cell.getInitialValue() }}
              }
            </div>
          }
        }
      </div>
    `,
    standalone: false
})
export class ViewCellComponent {
  @Input() public cell: Cell;
  @Output() public linkClickEvent = new EventEmitter<any>();
  constructor() {
    // empty
  }
  public hideLink(): boolean {
    if (this.cell.getColumn().title === 'Action') {
      if (this.cell.getInitialValue().indexOf('Office Update(') === -1) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }
  public onLinkClick(event: any) {
    event.preventDefault();
    this.linkClickEvent.emit();
  }
}
